import React from 'react';
import { ContentSection } from '../ui/ContentSection';
import { CTAButton } from '../ui/CTAButton';
export function FinalCTA() {
  return <ContentSection background="white" className="text-center" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-4xl md:text-6xl font-bold text-[#1A1A1A] mb-6 leading-tight" data-id="element-29">
          Deja de correr. <br data-id="element-30" />
          <span className="text-amber-600" data-id="element-31">Empieza a dirigir.</span>
        </h2>

        <div className="prose prose-xl mx-auto text-gray-600 mb-12" data-id="element-32">
          <p data-id="element-33">
            No necesitas más fuerza. No necesitas más horas. No necesitas más
            presión.
          </p>
          <p data-id="element-34">
            Necesitas un estándar más alto para tu tiempo, tu energía y tu foco.
          </p>
          <p className="font-medium text-gray-900" data-id="element-35">
            Cuando eso se ordena, la vida deja de sentirse como una carrera y
            empieza a sentirse como una dirección.
          </p>
        </div>

        <CTAButton href="https://coneckta.co/ebookjuegadesdeotronivel" className="mx-auto text-xl px-10 py-5" data-id="element-36">
          Quiero jugar desde otro nivel
        </CTAButton>
      </div>
    </ContentSection>;
}